const React = require('react');


module.exports = (props) => {
  return (
    <div
      {...props}
      className={`layoutRow fhaS fvaC h70 ph35 pv5 dn bgF.03:h w bc4B4D51
          bs b bb1 ` + (props.className || '')}
    />
  );
};
